















































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SeniorityLevelComponent extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  label!: String;

  @Prop({
    type: String,
    default: 'NOVICE',
  })
  value!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly!: boolean;

  updateValue(value: string): void {
    this.$emit('input', value);
  }

  levelLabels = {
    NOVICE: {
      text: 'Aprendiz',
      description: 'É um iniciante no tema, está aprendendo e executa com apoio e orientação;',
    },
    PRACTICING: {
      text: 'Praticante',
      description: 'Possui conhecimento sobre o tema, está praticando sem maiores problemas, mas ainda tem o que aprender;',
    },
    PROFESSIONAL: {
      text: 'Profissional',
      description: 'Domina o tema e possui habilidade profissional, executando com autonomia, performance e qualidade;',
    },
    EXPERT: {
      text: 'Expert',
      description: 'É referência para outros, executando de forma exemplar, acima do que se espera de um profissional normal;',
    },
  }
}
